export default "__VITE_ASSET__CajWR4KH__"